export default {
  data() {
    return {
      isSelect: false,
    };
  },
  props: ['option', 'componentSelect', 'index'],
  watch: {
    componentSelect(n) {
      if (n === this.option.component_id) this.isSelect = true;
      else this.isSelect = false;
    },
  },
  render(createElement) {
    const self = this;
    if (self?.option?.elements?.length) {
      const classes = ['body_component', 'go-report-section'];
      if (self.isSelect) classes.push('component_select');
      return createElement(
        'div',
        {
          class: classes,
          on: {
            click() {
              self.isSelect = true;
              self.$emit('selectBody', self.option.component_id, self.option.reference_doc_ids);
            },
          },
        },
        self?.option?.elements.map(function (item) {
          switch (item.element_type) {
            case 'heading':
              return createElement('h2', `${self.index + 1}. ${item.content}`);
            case 'entry':
              break;
            case 'list':
              if (item.contents?.length > 0) {
                return createElement(
                  'ul',
                  {
                    class: ['go-report-list-disc go-report-source'],
                  },
                  item.contents.map(function (obj) {
                    return createElement(
                      'li',
                      {
                        on: {
                          click() {
                            self.$root.$emit('select-reference-document', obj.doc_id);
                          },
                        },
                      },
                      [
                        createElement('p', { class: ['source-title'] }, obj.title),
                        createElement('a', { class: ['source-link'] }, `https://goover.ai/detail-feed/${obj.doc_id}`),
                      ]
                    );
                  })
                );
              }
              break;
            default:
              return createElement('p', item.content);
          }
        })
      );
    }
  },
};
